import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatBytes",
  standalone: true,
})
export class FormatBytesPipe implements PipeTransform {
  transform(bytes: number | null | undefined): string {
    if (bytes == null || bytes === 0) {
      return "0.00 B";
    }

    const e = Math.floor(Math.log(bytes) / Math.log(1024));
    return (
      (bytes / Math.pow(1024, e)).toFixed(2) + " " + " KMGTP".charAt(e) + "B"
    );
  }
}
